<script setup lang="ts">
const {
    infotext = null,
    html = false,
    left = false,
    right = false,
    bottom = false,
    top = false,
} = defineProps<{
    infotext: string | null
    html?: boolean
    left?: boolean
    right?: boolean
    bottom?: boolean
    top?: boolean
}>()
</script>

<template>
    <v-tooltip v-if="infotext" :left="left" :right="right" :top="top" :bottom="bottom" open-on-click>
        <template v-slot:activator="{ props: activatorProps }">
            <v-icon color="primary" dark v-bind="activatorProps" class="ml-4">fas fa-info-circle</v-icon>
        </template>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-if="html" v-html="infotext"></span>
        <span v-else>{{ infotext }}</span>
    </v-tooltip>
</template>
